import { type FC } from 'react';

import { useListingContext } from '@/microfrontends/listing/shared/context/ListingContext';

import { useGetInfiniteSearchResultDesktopByListingQuery } from '@/packages/query-state/shared/store/search-offers/v2/get-infinite-search-result-desktop/query';
import { useIntersectionObserver } from '@/packages/react-utils/useIntersectionObserver';

import { useInitSimilarOffersCardApi } from '../../hooks/useInitCardApi';
import { CardsWithAdsContainer } from '../CardsWithAdsContainer';
import { VisitedOffersAnalytics } from '../VisitedOffersAnalytics';

import { OtherCards } from './components/OtherCards';
import { trackOtherCardsShow } from './tracking';
import { infiniteOffersDataToOffers } from './utils';

export const SimilarOffersCardsContainer: FC = () => {
  const { data, hasNextPage, isFetching, fetchNextPage } = useGetInfiniteSearchResultDesktopByListingQuery();
  const initCardApi = useInitSimilarOffersCardApi();

  const {
    adfox,
    listingProperties: { dealType },
  } = useListingContext();

  const { elementRef } = useIntersectionObserver<HTMLDivElement>(
    {
      onInViewport({ observer }) {
        if (data?.pages.length) {
          observer.disconnect();

          const offers = infiniteOffersDataToOffers(data);

          trackOtherCardsShow(offers);
        }
      },
    },
    [data],
  );

  if (!data?.pages.length) {
    return null;
  }

  const offers = infiniteOffersDataToOffers(data);

  return (
    <>
      <OtherCards
        hasNextPage={!!hasNextPage}
        isLoading={isFetching}
        ref={elementRef}
        title="Похожие предложения"
        onMoreButtonClick={(): void => {
          fetchNextPage();
        }}
      >
        <CardsWithAdsContainer adfox={adfox} dealType={dealType} initCardApi={initCardApi} offers={offers} />
      </OtherCards>
      <VisitedOffersAnalytics isFetchingOffers={isFetching} offers={offers} />
    </>
  );
};
